import React, { useContext } from 'react';
import { Button, Icon, useScreenClass } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import PropTypes from 'prop-types';
import useSiteData from '../../hooks/useSiteData';
import { SourcePageContext } from '../contexts/SourcePageContext';
import { trackPrintOrderDetailsClicked } from '../../apis/newRelicTrackingApi';

export const PrintOrderDetailsButton = ({ order }) => {
  const [orderDetailsMessages] = useTranslations(['orderDetailsMessages']);

  const { printerFriendlyEnabled, vistacartTenantName } = useSiteData();
  const { sourcePage } = useContext(SourcePageContext);
  const screenClass = useScreenClass();

  const handlePrintClicked = () => {
    const trackingData = {
      orderNumber: order.orderNumber,
      vistacartTenantName,
      page: sourcePage,
    };
    trackPrintOrderDetailsClicked(order.shopperId, trackingData);
    window.print();
  };

  if (printerFriendlyEnabled) {
    return (
      <Button
        width={['xs', 'sm'].includes(screenClass) ? 'full-width' : 'standard'}
        onClick={() => handlePrintClicked()}
        data-testid="print-order-details-button"
      >
        {orderDetailsMessages.printField}
        <Icon iconType="fileGeneric" size="20p" aria-hidden="true" />
      </Button>
    );
  }

  return null;
};

PrintOrderDetailsButton.propTypes = {
  order: PropTypes.object.isRequired,
};
